<template>
  <pre ref="container" v-html="output"></pre>
</template>

<script>
import AnsiUp from "ansi_up";
import { computed } from "@vue/composition-api";

export default {
  name: "ConsoleOutput",
  props: {
    content: String,
    ansi: Boolean,
  },
  setup(props, { root }) {
    const formatter = new AnsiUp();
    const formatOutput = (str) => {
      return props.ansi ? formatter.ansi_to_html(str) : str;
    };

    const output = computed(() => {
      const out = formatOutput(props.content);
      if (root.$refs.container) {
        root.$refs.container.scrollTop = root.$refs.container.scrollHeight || 0;
      }
      return out;
    });

    return { output };
  },
};
</script>

<style scoped>
pre {
  height: 600px;
  overflow: scroll;
}
</style>
